import { TEventPayload } from '@libs/types';

export type TFunctionParsed = {
    internalIds: string[];
    widgets: Record<string, TEventPayload['value']>;
    conditions: Array<TConditions>;
};
export type TParameter = {
    internalId?: string;
    value: TEventPayload['value'];
};
export type TConditions = {
    firstParameter: TParameter;
    secondParameter: TParameter;
    conditionAction: ConditionActionEnum;
    joinConditionAction?: JoinConditionActionEnum;
};

export enum JoinConditionActionEnum {
    AND = '&&',
    OR = '||',
}

export enum ConditionActionEnum {
    EQUAL = '==',
    NOT_EQUAL = '!=',
    MORE_THAN = '>',
    LESS_THAN = '<',
    MORE_THAN_OR_EQUAL = '>=',
    LESS_THAN_OR_EQUAL = '<=',
}

/*
    @match0 - whole expression
    @match1 - validationId or number or boolean
    @match2 - string value
    @match3 - property name of widget with '.'
    @match4 - property name of widget
    @match5 - conditional operator (==, >, <, >=, <=)
    @match6 - validationId or number or boolean
    @match7 - string value
    @match8 - property name of widget with '.'
    @match9 - property name of widget
    @match10 - conditional operator between expressions (||, &&)
 */
const objectRegex = /(\w+|\d+|(.*?))(\.(\w+))?(={2}|<|\\>|>=|=<|!=){1,}(\w+|\d+|(.*?))(\.(\w+))?(\|{2}|&{2})?/g;
export const parseToPrimitive = (str: string): boolean | number | string => {
    if (str === 'true' || str === 'false') {
        return str === 'true';
    } else if (str !== '' && !isNaN(+str)) {
        return Number(str);
    }
    return str;
};
export const parseStringToFunctionObject = (constraint: string): TFunctionParsed => {
    const result: TFunctionParsed = { internalIds: [], widgets: {}, conditions: [] };
    if (constraint) {
        try {
            const matches = constraint.matchAll(objectRegex);
            for (const match of matches) {
                const condition: TConditions = {
                    firstParameter: { value: parseToPrimitive(match?.[2] ?? match?.[1]) },
                    secondParameter: { value: parseToPrimitive(match?.[7] ?? match?.[6]) },
                    conditionAction: match?.[5] as ConditionActionEnum,
                    joinConditionAction: match?.[10] as JoinConditionActionEnum,
                };
                if (match?.[1] && match?.[4]) {
                    result.internalIds.push(match[1]);
                    result.widgets[match[1]] = match[4];
                    condition.firstParameter.value = null;
                    condition.firstParameter.internalId = match[1];
                }
                if (match?.[6] && match?.[9]) {
                    result.internalIds.push(match[6]);
                    result.widgets[match[6]] = match[9];
                    condition.secondParameter.value = null;
                    condition.secondParameter.internalId = match[6];
                }

                result.conditions.push(condition);
            }
        } catch (e) {
            console.error(e);
        }
    }
    return result;
};
export const updateConditionValues = (conditions: Array<TConditions>, internalId: string, value: TEventPayload['value']) => {
    conditions.forEach((condition) => {
        if (condition.firstParameter.internalId === internalId) {
            condition.firstParameter.value = value;
        }
        if (condition.secondParameter.internalId === internalId) {
            condition.secondParameter.value = value;
        }
    });
};
